<template>
	<div class="el-loading-mask" v-if="config.show">
		<div class="el-loading-spinner">
			<i class="el-icon-loading" style=" color:#fff;
                    font-size:24px;"></i>
			<p class="el-loading-text" style="color:#fff;margin-top: 20px;">{{config.info}}</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		config: {
			type: Object
		}
	},
	data() {
		return {

		}
	}
}

</script>

<style scoped lang="scss">
	.el-loading-mask {
		width: 100%;
		height: 100%;
		background: transparent;
	}

	.el-loading-spinner {
		width: 120px;
		height: 150px;
		padding-top: 30px;
		background: rgba(1, 1, 1, .4);
		left: 50%;
		top: 50%;
		border-radius: 10px;
		color: #fff;
		transform: translate(-60px, -75px);
	}

</style>
